export enum ConferencingEvent {
  PresenterAttendanceChanged = 'conferencing:presenter-attendance-changed',
}
